import { createReducer, PayloadAction } from '@reduxjs/toolkit'
import { Investments, ReducerState } from '@interfaces'
import { fetchInvestments, sortPortfolioPositions } from './thunk'
import { sortByObjectProperty } from '@utils/sortByObjectProperty'
import { PortfolioSortingTypes } from '@interfaces/portfolioSortingTypes'

const initialState: Investments & ReducerState = {
  currentValue: { amount: 0, currency: 'EUR' },
  totalEarnings: { amount: 0, currency: 'EUR' },
  totalEarningsToday: { amount: 0, currency: 'EUR' },
  totalPerformanceToday: 0,
  totalPerformance: 0,
  portfolios: [],
  error: null,
  loading: true,
  id: null,
}

export const reducers = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchInvestments.pending, (acc) => {
      acc.loading = true
      acc.error = null
    })
    .addCase(
      fetchInvestments.fulfilled,
      (acc, action: PayloadAction<Investments>) => {
        const { payload } = action
        acc.currentValue = payload.currentValue
        acc.totalEarnings = payload.totalEarnings
        acc.totalEarningsToday = payload.totalEarningsToday
        acc.totalPerformanceToday = payload.totalPerformanceToday
        acc.totalPerformance = payload.totalPerformance
        acc.portfolios = payload.portfolios
        acc.id = payload.id
        acc.loading = false
        acc.error = null
      },
    )
    .addCase(sortPortfolioPositions, (acc, { payload }) => {
      let field: string

      if (payload?.sortBy === PortfolioSortingTypes.PNL) {
        field = 'totalEarnings.amount'
      }

      if (payload?.sortBy === PortfolioSortingTypes.POSITION) {
        field = 'currentValue.amount'
      }

      if (payload?.sortBy === PortfolioSortingTypes.ALPH) {
        field = 'name'
      }

      acc.portfolios?.forEach((p, idx) => {
        const copy = [...(p?.positions || [])]
        const sorted = sortByObjectProperty(copy, field, payload?.sortDir)
        acc.portfolios[idx].positions = sorted
      })
    })
    .addCase(fetchInvestments.rejected, (acc, { error }) => {
      acc.loading = false
      acc.error = error.message || ''
    })
})

export default reducers
